import React from "react";
import logo from "../../assets/images/navbar/logo.png";
import "./footer.css";
export default function Footer() {
  return (
    <div className="footer-container">
      <div className="container d-flex justify-content-center align-items-center pt-2 pb-2 border-bottom">
        <div className="row">
          <div className="col-md-4 col-sm-12 px-5">
            <img src={logo} alt="virtual-logo" className="w-100" />
            <p className="text-white mt-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut.
            </p>
          </div>
          {/* About us Section */}
          <div className="col-md-2 col-sm-4">
            <div className="row">
              <div className="col-12 d-flex align-items-start">
                <h1 className="footer-headings">About Us</h1>
              </div>
              <div className="col-12 d-flex flex-column align-items-start">
                <span className="sub-headings">Terms</span>
                <span className="sub-headings">Privacy</span>
                <span className="sub-headings">Announcements</span>
              </div>
            </div>
          </div>
          {/* Academy Section */}
          <div className="col-md-2 col-sm-4">
            <div className="row">
              <div className="col-12 d-flex align-items-start">
                <h1 className="footer-headings">Academy</h1>
              </div>
              <div className="col-12 d-flex flex-column align-items-start">
                <span className="sub-headings">Beginners Center</span>
                <span className="sub-headings">Spot Trading</span>
                <span className="sub-headings">Futures Trading</span>
                <span className="sub-headings">FAQ</span>
              </div>
            </div>
          </div>
          {/* Service Section */}
          <div className="col-md-2 col-sm-4 ">
            <div className="row">
              <div className="col-12 d-flex align-items-start">
                <h1 className="footer-headings">Service</h1>
              </div>
              <div className="col-12 d-flex flex-column align-items-start">
                <span className="sub-headings">Fees</span>
                <span className="sub-headings">Rules</span>
                <span className="sub-headings">Listing Application</span>
                <span className="sub-headings">Referral</span>
                <span className="sub-headings">DAO</span>
              </div>
            </div>
          </div>
          {/* Contact us section */}
          <div className="col-md-2 col-sm-4 ">
            <div className="row">
              <div className="col-12 d-flex align-items-start">
                <h1 className="footer-headings">Contact Us</h1>
              </div>
              <div className="col-12 d-flex flex-column align-items-start">
                <span className="sub-headings">Help Center</span>
                <span className="sub-headings">Submit a Request</span>
                <span className="sub-headings">Business Contacts</span>
                <span className="sub-headings">Institutional Cooperation</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="row ">
        <div className="col-12 d-flex justify-content-center my-1">
          <p className="text-white m-0">
            Copyright © 2023 Virtual Tech All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
